<template>
  <modal-template
    ref="modal"
    title="Por favor, digite seu e-mail abaixo."
    type-modal="forgot_password_modal"
  >
    <div class="modal-content__main">
      <d-form-input
        @keydown.enter="sendEmailForgotPassword()"
        type="text"
        placeholder="E-mail"
        v-model="forgot.email"
      />
    </div>

    <div slot="actions" class="modal-content__control" >
      <loader v-if="loading" :fullPage="false" class="mr-4"/>
      <d-button
        type="button"
        :disabled="loading"
        @click="sendEmailForgotPassword()"
        class="btn btn-sm btn-primary"
      >Enviar solicitação de mudança de senha</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import ModalTemplate from '_shared/Modal.vue';
import Loader from '_shared/Loader.vue';

export default {
  data() {
    return {
      forgot: {
        email: null,
        error: false,
      },
      loading: false,
    };
  },
  components: {
    Loader,
    ModalTemplate,
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'sendForgotPass',
    ]),
    sendEmailForgotPassword() {
      if (this.forgot.email) {
        this.loading = true;
        this.sendForgotPass(this.forgot.email)
          .then(response => {
            this.loading = false;
            this.$router.push({
              path: '/public/login',
              query: { forgot: 'true' },
            });
            this.$refs.modal.setClose();
            this.activeAlert({ message: response.message, theme: 'success' });
          })
          .catch(() => {
            this.loading = false;
            this.$refs.modal.setClose();
            this.activeAlert({
              message: 'E-mail é inválido',
              theme: 'danger',
            });
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
